import req from "../http";

const talentPool = {
  // 人才 查詢
  getTalent(params) {
    return req("post", "/TalentData/TalentPool/Search", params);
  },

  // 人才 匯出
  exportTalent(params) {
    return req("post", "/TalentData/TalentPool/Export", params, { responseType: "blob" });
  },

  // 解除 黑名單
  removeBlacklist(params) {
    return req("post", "/TalentData/Blacklist/RemoveBatch", params);
  },

  // 取得 黑名單歷程
  getBlackHistory(params) {
    return req("get", `/TalentData/Blacklist/GetHistory/${params}`);
  }
};

export default talentPool;